module.exports = __webpack_public_path__ + "static/media/DSCF6534.7b8afb16.jpg";